<div class="right-side-panel">
  <div class="side-panel-container">
    <div class="side-panel-header">
      <div *ngIf="title" class="side-panel-title">
        <div class="side-panel-title-text">
          {{ title }}
        </div>
      </div>
      <dx-button
        class="open-button"
        stylingMode="text"
        [icon]="isOpened ? (isLarge ? 'panelleft' : 'close') : 'panelright'"
        (onClick)="toggleOpen()"
      >
      </dx-button>
    </div>

    <div class="side-panel-content-wrapper">
      <ng-content></ng-content>
    </div>
  </div>
</div>
